import React from "react";
// import QRCode from 'react-qr-code';
import { InamdarHospiLogo } from "../../assets/printAssets/InmadarHospiLogo";
import PrintDefaultIMG from "../components/assets/printDefaultIMG.png";
const PassPrint = ({ passData }) => {
  console.log("passData", passData);

  return (
    <div className=" px-4 py-1 border border-gray-400 rounded shadow-md mx-auto bg-white">
      <div className="flex justify-between items-center">
        {/* <img
                    src={InamdarHospiLogo}
                    alt='Logo'
                /> */}
        <InamdarHospiLogo />
        <img
          src={
            passData?.Image
              ? `data:image/jpeg;base64,${passData.Image}`
              : PrintDefaultIMG
          }
          alt="Profile"
          className="rounded-lg"
          style={{
            width: "5rem",
            height: "5rem",
            objectFit: "cover",
          }}
        />
      </div>
      <hr className="border-black mb-2" />

      <table className="w-full text-left text-[12px]">
        <tbody>
          <tr>
            <td className="font-semibold w-[43%] pr-2">Pass ID</td>
            <td>
              :{"  "}
              {passData?.["Id"] || "  "}
            </td>
          </tr>
          <tr>
            <td className="font-semibold pr-2">Pass Type</td>
            <td>
              :{"  "}
              {passData?.["Pass Type"] || "  "}
            </td>
          </tr>
          <tr>
            <td className="font-semibold pr-2">Visitor's Name</td>
            <td>
              :{"  "}
              {passData?.["Visitor Name"] || "  "}
            </td>
          </tr>
          {["vendor", "contractor"]?.includes(
            passData?.["Pass Type"]?.toLowerCase()
          ) && (
            <tr>
              <td className="font-semibold pr-2">Visitor's Company</td>
              <td>
                :{"  "}
                {passData?.["Company Name"] || " "}
              </td>
            </tr>
          )}

          <tr>
            <td className="font-semibold pr-2">Visitor's Mobile</td>
            <td>
              :{"  "}
              {passData?.["Contact No"] || "  "}
            </td>
          </tr>
          {/* <tr>
                        <td className="font-semibold pr-2">Valid Till</td>
                        <td>:{" "}{passData?.["Check In"] || " " + "  " + passData?.["Check Out"] || " "}</td>
                    </tr> */}
          <tr>
            <td className="font-semibold pr-2">
              {passData?.["Whom To Meet"] !== null
                ? "Whom To Meet"
                : "Patient Name"}
            </td>
            <td>
              :{"  "}
              {passData?.["Whom To Meet"] !== null
                ? passData?.["Whom To Meet"]
                : passData?.["Patient Name"] || " "}
            </td>
          </tr>
          {["patient visitor"]?.includes(
            passData?.["Pass Type"]?.toLowerCase()
          ) && (
            <tr>
              <td className="font-semibold pr-2">Age</td>
              <td>
                :{"  "}
                {passData?.["Age"] || "  "}
              </td>
            </tr>
          )}
          <tr>
            <td className="font-semibold pr-2">Department</td>
            <td>
              :{"  "}
              {passData?.["Department"] ||
                passData?.["Patient Department"] ||
                "  "}
            </td>
          </tr>
          <tr>
            <td className="font-semibold pr-2">
              {["patient visitor"]?.includes(
                passData?.["Pass Type"]?.toLowerCase()
              )
                ? "Ward"
                : "Location"}
            </td>
            <td>
              :{"  "}
              {["patient visitor"]?.includes(
                passData?.["Pass Type"]?.toLowerCase()
              )
                ? passData?.["Patient Ward"]
                : passData?.["Location"] || "  "}
            </td>
          </tr>
          {["patient visitor"]?.includes(
            passData?.["Pass Type"]?.toLowerCase()
          ) && (
            <tr>
              <td className="font-semibold pr-2">Bed No.</td>
              <td>
                :{"  "}
                {passData?.["Bed No"] || "  "}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <hr className="border-black my-2" />
      <table className="w-full text-left text-[12px]">
        <tbody>
          <tr>
            <td className="font-semibold  w-[43%] pr-2">Luggage</td>
            <td>
              :{"  "}
              {passData?.["Luggaage"] || "  "}
            </td>
          </tr>
          <tr>
            <td className="font-semibold pr-2">Vehicle Details</td>
            <td>
              :{"  "}
              {passData?.["Vehicle Details"] || "  "}
            </td>
          </tr>
        </tbody>
      </table>

      {/* <hr className="border-black my-2" />

      <div className="mt-6 flex flex-col gap-y-3 items-center">
        <QRCode value={`https://appystack.com`} size={100} />
        <p className="text-xs mt-2 text-[#9CA3AF]">
          Powered by Appystack Pvt. Ltd.
        </p>
      </div> */}
    </div>
  );
};

export default PassPrint;
